import { Router } from 'preact-router';
import { memo } from 'preact/compat';
import { BASE_URL } from "./config";

// Code-splitting is automated for routes
import Home from './routes/home';
import Contacts from './routes/contacts';
import Metaverse from "./routes/metaverse";
import About from './routes/about';
import Forbes from './routes/forbes';
import Forbesresearch from './routes/forbesresearch';
import Omnichannel from './routes/omnichannel';
import Chatbotstudio from './routes/chatbotstudio';
import Careers from './routes/careers';
import Partners from './routes/partners';
import Becomeapartner from './routes/becomeapartner';
import Register from './routes/register';
import Login from './routes/login';
import Forgotpw from './routes/forgotpw';
import Pricing from "./routes/pricing";
import Michelangelo from "./routes/michelangelo";
import Landinguniversity from './routes/landinguniversity';
import Privacy from './routes/privacy';
import Terms from './routes/terms';
import Cookies from './routes/cookies';
import Faqs from './routes/faqs';
import WebsiteDisclaimer from './routes/website_disclaimer';
import Becomeanexpert from "./routes/becomeanexpert";
import Experts from "./routes/experts";
import Digitaltwin from "./routes/digitaltwin";
import DigitaltwinList from "./routes/digitaltwinlist";
import Interview from "./routes/interview";
import Schools from "./routes/schools";
import Dicci from "./routes/dicci";
import Restaurants from "./routes/restaurants";
import Startup_evaluation from "./routes/startup_evaluation";
import Chatwrp from "./components/chatwrp";

const AppRouter = memo(({ handleRoute, handleYTRequest, checkLoggedIn, handleChatRequest }) => (
  <Router onChange={handleRoute}>
    <Home path={BASE_URL} ytCB={handleYTRequest} default />
    <About path={BASE_URL + 'about/'} />
    <Metaverse path={BASE_URL + 'products/metaverse/'} />
    <Chatwrp path={BASE_URL + 'chatwrp/:chatID'} />
    <Chatwrp path={BASE_URL + 'chatwrp'} />
    <Interview path={BASE_URL + 'interview'} />
    <Interview path={BASE_URL + 'interview/:lang'} />
    <Omnichannel path={BASE_URL + 'products/omni-channel'} />
    <Chatbotstudio ytCB={handleYTRequest} path={BASE_URL + 'products/chatbot-studio/:lang?'} />

    <Careers path={BASE_URL + 'careers'} />
    <Schools path={BASE_URL + 'products/schools-assistant/:lang?'} />
    <Dicci path={BASE_URL + 'products/municipal-assistant/:lang?'} />
    <Restaurants path={BASE_URL + 'products/restaurant-assistant/:lang?'} />

    <Partners path={BASE_URL + 'partners/list'} />
    <Becomeapartner path={BASE_URL + 'partners/join'} />

    <Experts path={BASE_URL + 'experts'} />
    <Becomeanexpert path={BASE_URL + 'experts/join'} />

    <Forbes path={BASE_URL + 'forbes-insights'} />
    <Forbesresearch path={BASE_URL + 'forbes-insights/research'} />
    <Forbes path={BASE_URL + 'partners/forbes-insights'} />

    <Contacts path={BASE_URL + 'contacts'} />
    <Pricing path={BASE_URL + 'pricing'} />
    <Register isLoggedIn={checkLoggedIn} path={BASE_URL + 'register'} />
    <Login isLoggedIn={checkLoggedIn} path={BASE_URL + 'login'} />
    <Forgotpw path={BASE_URL + 'reset-password/:token?'} />
    <Terms path={BASE_URL + 'terms'} />
    <Digitaltwin path={BASE_URL + 'digitaltwin'} />
    <DigitaltwinList path={BASE_URL + 'digitaltwin/list/:type?'} />
    <Privacy path={BASE_URL + 'privacy'} />
    <Faqs path={BASE_URL + 'faqs'} />
    <Cookies path={BASE_URL + 'cookies'} />
    <WebsiteDisclaimer path={BASE_URL + 'website_disclaimer'} />
    <Michelangelo chatCB={handleChatRequest} path={BASE_URL + 'michelangelo'} />
    <Landinguniversity path={BASE_URL + 'landings/education'} />
    <Startup_evaluation path={BASE_URL + 'startup_evaluation'} />
  </Router>
));

export default AppRouter;
